import { EditorEligibilityRule } from './editor-eligibility-rule.model';


export class EditorEligibilityRuleHasBookingItem extends EditorEligibilityRule {
  className = 'HasBookingItem';
  operatorName = 'hasBookingItem';

  bookingItems: string[];
  // states: string[];
  stateNamesString: string;
  metadata: string[];

  constructor(obj?: any) {
    super({
      id: obj?.id ?? null
    });
    this.bookingItems = obj?.bookingItems ?? [];
    // this.states = obj?.states ?? [];
    this.stateNamesString = obj?.stateNamesString ?? '';
    this.metadata = obj?.metadata ?? [];
  }

  static matchesTypeOfLegacySerializedValues(legacyEligibilityRules: any) {
    return legacyEligibilityRules?.args?.[0]?.args?.[0]?.op === 'fetchFromES'
      && legacyEligibilityRules?.args?.[0]?.args?.[0]?.options?.type === 'booking'
      && legacyEligibilityRules?.args?.[0]?.args?.[0]?.options?.filter?.bookingItem !== undefined
      && legacyEligibilityRules?.args?.[0]?.args?.[0]?.options?.filter?.bookingOption === undefined;
  }

  static getFromLegacySerializedValues(legacyEligibilityRules: any) {
    let states = legacyEligibilityRules.args[0].args[0].options.filter?.['es_extra.stateName'];
    if (typeof(states) === 'string') {
      states = [states];
    }

    const metadata = Object.keys(legacyEligibilityRules.args[0].args[0].options.filter)
      .filter(key => key.substring(0, 8) === 'metadata')
      .map(key => key.substring(9));

    return new this({
      bookingItems: typeof(legacyEligibilityRules.args[0].args[0].options.filter.bookingItem) === 'string'
      ? [legacyEligibilityRules.args[0].args[0].options.filter.bookingItem]
      : legacyEligibilityRules.args[0].args[0].options.filter.bookingItem,
      stateNamesString: states === undefined ? null : states.join(', '),
      metadata
    });
  }

  static getFromSerializedValues(serializedValues: any) {
    return new this({
      bookingItems: serializedValues.bookingItems,
      stateNamesString: serializedValues.states.join(', '),
      metadata: serializedValues.metadata
    });
  }

  static getEmptyControlConfig(): { [key: string]: any; } {
    return {
      bookingItems: [{ value: [], disabled: true }],
      // states: [{ value: [], disabled: true }],
      stateNamesString: [{ value: '', disabled: true }, EditorEligibilityRuleHasBookingItem.getStateNamesStringControlOptions()],
      metadata: [{ value: [], disabled: true }]
    };
  }

  static getStateNamesStringControlOptions(): any {
    return {
      validators: [],
      updateOn: 'blur'
    };
  }

  createCopy(): EditorEligibilityRuleHasBookingItem {
    return new EditorEligibilityRuleHasBookingItem({
      id: this.id,
      bookingItems: [...this.bookingItems],
      // states: [...this.states],
      stateNamesString: this.stateNamesString,
      metadata: [...this.metadata]
    });
  }

  getBookingItemsAsString(bookingItemNames: { id: string, name: string }[]): string {
    if (this.bookingItems.length === 0) { return ''; }
    return this.bookingItems
      .map(bookingItem =>
        bookingItemNames.find(bookingItemName => bookingItemName.id === bookingItem) ?? { id: bookingItem, name: $localize `Not valid` }
      )
      .map(bookingItemName => bookingItemName.name)
      .join(', ');
  }
/*
  getBookingStatesAsString(bookingStateNames: { id: string, name: string }[]): string {
    if (this.states.length === 0) { return ''; }
    return this.states
      .map(state =>
        bookingStateNames.find(bookingStateName => bookingStateName.id === state) ?? { id: state, name: $localize `Not valid` }
      )
      .map(bookingStateName => bookingStateName.name)
      .join(', ');
  }
*/
  getBookingMetadataAsString(bookingMetadataNames: { id: string, name: string }[]): string {
    if (this.metadata.length === 0) { return ''; }
    return this.metadata
      .map(metadata =>
        bookingMetadataNames.find(bookingMetadataName => bookingMetadataName.id === metadata) ?? { id: metadata, name: $localize `Not valid` }
      )
      .map(bookingMetadataName => bookingMetadataName.name)
      .join(', ');
  }

  getControlsConfig(): { [key: string]: any; } {
    return {
      bookingItems: [this.bookingItems],
      // states: [this.states],
      stateNamesString: [this.stateNamesString, EditorEligibilityRuleHasBookingItem.getStateNamesStringControlOptions()],
      metadata: [this.metadata],
    };
  }

  getSerializedValues(): any {
    return {
      bookingItems: this.bookingItems,
      // states: this.states,
      states: this.stateNamesString === '' ? [] : this.stateNamesString.split(',').map(itm => itm.trim().toUpperCase()),
      metadata: this.metadata
    };
  }
}
